import {Mapper} from '@s-ui/domain'

export default class FromInfoVehicleRawDataToInfoVehicleValueObjectMapper extends Mapper {
  constructor({valueObject}) {
    super()
    this._valueObject = valueObject
  }

  map = rawInfoVehicle => this._valueObject({...rawInfoVehicle})
}
